import { render } from "./Confirm.vue?vue&type=template&id=bc0a0a72"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
script.render = render

export default script